import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AdminLayout } from '~/components/layout/admin-layout'
import { currentFootballCoreLocation } from '~/lib/navigation/football-core'
import { createSessionQuery } from '~/lib/session-query'

export const Route = createFileRoute('/admin')({
  beforeLoad: async ({ context, location }) => {
    // 强制获取 session 数据
    const session = await context.queryClient.fetchQuery(
      createSessionQuery(context.queryClient),
    )

    const returnTo = currentFootballCoreLocation(location)
    if (!session?.session) {
      throw redirect({
        href: `/auth/sign-in?returnTo=${encodeURIComponent(returnTo)}`,
        replace: true,
      })
    }

    if (session.user?.role !== 'admin') {
      throw redirect({
        href: `/forbidden?returnTo=${encodeURIComponent(returnTo)}`,
        replace: true,
      })
    }

    return {
      session,
    }
  },
  component: AdminLayoutComponent,
})

function AdminLayoutComponent() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  )
}
